var modalItems = [];
var currentIndex = 0;
var arrowTimeout; // timeout রাখার জন্য

function openImageModalByIndex(index) {
  const item = modalItems[index];
  if (!item) return;

  if (item.type === "image") {
    currentIndex = index;
    showModalItem();
    document.getElementById("productModal").style.display = "flex";
    document.body.style.overflow = "hidden"; // ✅ scroll off
    showArrows(); // modal open হলে arrow দেখাও
  } else if (item.type === "video") {
    const videoEl = document.querySelectorAll(".product__main-item-img video")[
      index
    ];
    if (videoEl.paused) {
      videoEl.play();
    } else {
      videoEl.pause();
    }
  }
}

function showModalItem() {
  const modalContent = document.getElementById("modalContent");
  modalContent.innerHTML = "";

  let item = modalItems[currentIndex];

  // যদি current item video হয়, তাহলে পরের image এ move করো
  let attempts = 0;
  while (item && item.type !== "image" && attempts < modalItems.length) {
    currentIndex = (currentIndex + 1) % modalItems.length;
    item = modalItems[currentIndex];
    attempts++;
  }

  if (item && item.type === "image") {
    modalContent.innerHTML = `<img src="${item.src}" alt="Product Image">`;
  }
}

function nextModalItem() {
  currentIndex = (currentIndex + 1) % modalItems.length;
  showModalItem();
  showArrows();
}

function prevModalItem() {
  currentIndex = (currentIndex - 1 + modalItems.length) % modalItems.length;
  showModalItem();
  showArrows();
}

function closeImageModal() {
  document.getElementById("productModal").style.display = "none";
  document.body.style.overflow = "";

  const arrows = document.querySelectorAll(".modal-prev, .modal-next");
  arrows.forEach((arrow) => arrow.classList.remove("visible"));

  if (arrowTimeout) clearTimeout(arrowTimeout);
}

function showArrows() {
  const arrows = document.querySelectorAll(".modal-prev, .modal-next");
  arrows.forEach((arrow) => arrow.classList.add("visible"));

  if (arrowTimeout) clearTimeout(arrowTimeout);

  // arrowTimeout = setTimeout(() => {
  //   arrows.forEach((arrow) => arrow.classList.remove("visible"));
  // }, 5000);
}

// DOM loaded
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("productModal");
  const modalContentWrapper = document.querySelector(
    ".product__main-img-modal-img"
  );

if (modal && modalContentWrapper && typeof closeImageModal === "function") {
  modal.addEventListener("click", function (e) {
    if (!modalContentWrapper.contains(e.target)) {
      closeImageModal();
    }
  });


  modal.addEventListener("mouseenter", showArrows);

}
  const mainSlides = document.querySelectorAll(".product__main-item-img");
  mainSlides.forEach((slide, index) => {
    const img = slide.querySelector("img");
    const video = slide.querySelector("video");

    if (img) {
      modalItems.push({ type: "image", src: img.src });
      img.addEventListener("click", () => openImageModalByIndex(index));
    }

    if (video) {
      modalItems.push({ type: "video", src: video.src });
      video.addEventListener("click", () => openImageModalByIndex(index));
    }
  });
});

// Thumbnail Swiper
var swiperThumbs = new Swiper(".product__small-img-wrapper", {
  spaceBetween: 10,
  slidesPerView: 6,
  freeMode: true,
  watchSlidesProgress: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2,
  },
});

// Main Swiper
var swiperMain = new Swiper(".product__main-img-wrap", {
  spaceBetween: 10,
    loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiperThumbs,
  },
});

// --- Video Handling ---
swiperMain.on("slideChange", function () {
  // Stop all videos first
  $(".product__main-item-img video").each(function () {
    this.pause();
    this.currentTime = 0;
  });

  // If active slide contains video, play it
  var $activeSlide = $(swiperMain.slides[swiperMain.activeIndex]);
  var $video = $activeSlide.find("video");
  if ($video.length) {
    $video.get(0).play();
  }
});

// --- Optional: Click to open PhotoSwipe gallery ---
$(document).on("click", ".product__main-item-img img", function (e) {
  e.preventDefault();

  var items = [];
  $(".product__main-item-img").each(function () {
    var $slide = $(this);
    var img = $slide.find("img");
    var video = $slide.find("video");

    if (img.length) {
      items.push({
        src: img.attr("src"),
        w: img[0].naturalWidth || 1200,
        h: img[0].naturalHeight || 1600,
      });
    } else if (video.length) {
      items.push({
        html:
          '<video src="' +
          video.attr("src") +
          '" controls autoplay style="max-width:100%;max-height:100%"></video>',
        w: 1200,
        h: 1600,
      });
    }
  });

  var activeIndex = swiperMain.activeIndex;
  callgalleryPhotoSwipe(activeIndex, items);
});


  $(document).on('change', '#product-select_ppr', function () {
    console.log('test253');

    const variantId = $(this).val();
    console.log('variantSelect', variantId);

    // Find the variant
    const newVariant = window.product?.variants?.find((v) => v.id == variantId);
    if (!newVariant) return;

    // Update global variant
    window.currentVariant = newVariant;

    // Update subscription price
    const subPlan = document.querySelector('subscription-plan');
    if (!subPlan || typeof subPlan.updatePrice !== 'function') return;

    const selectedPlan = subPlan.querySelector('.subscription-select')?.value || subPlan.hiddenInput?.value || null;

    subPlan.updatePrice(selectedPlan);
  });


$('.product-item--atc').click(function() {
  var variant_id = parseInt($(this).attr('variant-id'));

  $(this).closest('.nt_mini_cart').addClass('ld_nt_cl');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variant_id,
        quantity: 1
      }]
    })
  })
  .then(res => res.json())
  .then(data => {
  console.log("Added to cart:", data);




    $('.nt_mini_cart').removeClass('ld_nt_cl');


  })
  .catch(err => console.error("Add to cart error:", err));


});